import { useCallback } from 'react';

import { useQuery } from '../../../contexts/RouterContext';
import type { ReportsV3QueryParams } from '../types';

/**
 * Reads and writes the `fullList` query param for the executive vulnerability report.
 * The full vulnerability list is included unless the param is `'false'`.
 */
export const useExecutiveOptionsParams = (): [boolean, (isFullList: boolean) => void] => {
  const [query, setQuery] = useQuery<ReportsV3QueryParams>();
  const isFullList = query.fullList !== 'false';

  const setIsFullList = useCallback((value: boolean) => {
    setQuery({ ...query, fullList: value ? 'true' : 'false' });
  }, [query, setQuery]);

  return [isFullList, setIsFullList];
};
